import { logo } from "@/config/env"

export const LoadingLogo = () => {
   return (
      <div className="hero min-h-screen">
         <div className="hero-content text-center">
            <div className="max-w-md">
               <img src={logo} alt="Logo" className="w-32 mx-auto mb-4 animate-pulse" />
               <h1 className="text-xl font-bold">Télà?</h1>
               <span className="loading loading-spinner loading-lg"></span>
            </div>
         </div>
      </div>
   )
}
